import SchedulePage from './components/SchedulePage'

export default SchedulePage
